// extracted by mini-css-extract-plugin
export var chip = "_5f-9";
export var chipLabel = "_5f-a";
export var close = "_5f-7";
export var closeIcon = "_5f-8";
export var error = "_5f-6";
export var infoTooltip = "_5f-2";
export var innerContainer = "_5f-1";
export var input = "_5f-b";
export var medium = "_5f-5";
export var outerContainer = "_5f-0";
export var small = "_5f-4";
export var xSmall = "_5f-3";